<template>
  <v-container v-if="gebruiker">
    <h1>Details gebruiker</h1>
    <v-form v-model="valid" lazy-validation ref="form">
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Accountgegevens</v-card-title>
            <v-card-text>
              <v-text-field
                label="E-mailadres/loginnaam"
                v-model="gebruiker.Email"
                :disabled="gebruiker.Id != null"
                :rules="emailRules"
                required
                maxlength="250"
              ></v-text-field>
              <v-text-field label="Voornaam" v-model="gebruiker.FirstName" maxlength="100"></v-text-field>
              <v-text-field label="Tussenvoegsel" v-model="gebruiker.MiddleName" maxlength="10"></v-text-field>
              <v-text-field label="Achternaam" v-model="gebruiker.LastName" maxlength="250"></v-text-field>
              <v-text-field label="Personeelsnummer" v-model="gebruiker.Personeelsnummer" maxlength="25"></v-text-field>
              <v-checkbox label="Inloggen toestaan" v-model="gebruiker.Actief" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Rollen</v-card-title>
            <v-card-text>
              <v-checkbox
                v-for="(r,i) in gebruiker.Rol"
                :key="'rol'+i.toString()"
                v-model="r.Checked"
                :label="r.Naam"
              ></v-checkbox>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Profiel</v-card-title>
            <v-card-text>
              <v-select
                label="Profiel"
                v-model="gebruiker.ProfielId"
                :items="profielen"
                item-text="Naam"
                item-value="Id"
                required
                :rules="[v => !!v || 'Profiel is verplicht']"
              ></v-select>
              <v-btn fab color="secondary" title="Nieuw profiel maken">
                <v-icon>mdi-plus-thick</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Overig</v-card-title>
            <v-card-text>
              <v-radio-group v-model="gebruiker.AutomatischBladeren">
                <v-radio :value="false" label="Dashboardkeuzescherm"></v-radio>
                <v-radio :value="true">
                  <template v-slot:label>Automatisch bladeren.</template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn color="primary" @click="save()" :disabled="!valid">
            <v-icon left>mdi-content-save-outline</v-icon>Opslaan
          </v-btn>
          <v-btn class="mx-4" @click="cancel()">
            <v-icon left>mdi-close-circle</v-icon>Annuleren
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "BeheerGebruiker",
  data: () => ({
    profielen: [],
    gebruiker: null,
    valid: true,
    emailRules: [
      (v) => !!v || "E-mailadres is verplicht",
      (v) => /.+@.+/.test(v) || "E-mailadres is niet geldig",
    ],
  }),
  methods: {
    loadData: function () {
      this.$api.pProfielenGet().then((response) => {
        this.profielen = response.data;
      });
      this.$api.pUserGet({ UserId: this.$route.params.id }).then((response) => {
        this.gebruiker = response.data[0];
      });
    },
    save: function () {
      if (this.$refs.form.validate()) {
        this.$api.pUserSave(this.gebruiker).then((response) => {
          if (response.data[0].Success) {
            this.$router.push({ name: "beheergebruikers" });
          } else {
            alert(response.data[0].Msg);
          }
        });
      }
    },
    cancel: function () {
      this.$router.push({ name: "beheergebruikers" });
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
};
</script>